module.exports = __webpack_public_path__ + "img/icon_arrow_r2.714ecade.svg";